import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putMaintenance } from '../Api'

export default generateApiAction({
  baseType: Types.MAINTENANCES.PUT,
  api: putMaintenance,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/maintenances/PutAction.js